import React, { FunctionComponent, useMemo } from 'react';
import Translate from 'ui/atoms/translate';
import DataRecordTable, { CellTypeEnum } from 'src/libraries/data-record-table';
import { AdminApi, AdminIssuerList, AdminIssuersListOrderingEnum, AdminIssuersValuesRetrieveFieldEnum } from 'api';
import Number from 'ui/atoms/number';
import { DataRecordOrdering } from 'ui/types/data-ordering';
import { PaginationProps } from 'ui/molecules/pagination';
import useApiCall from 'src/hooks/use-api-call';

export interface StudioIssuersTableProps {
  ordering?: DataRecordOrdering;
  onOrderBy?: (fieldName: string) => void;
  issuers?: AdminIssuerList[];
  goToDetails: (investorId: string) => void;
  loading?: boolean;
  paginationProps?: PaginationProps;
  hasPermission: boolean;
  setFilterPopupHeight?: (height: number) => void;
}

const StudioIssuersTable: FunctionComponent<StudioIssuersTableProps> = (props) => {
  const { ordering, onOrderBy, issuers, goToDetails, loading, hasPermission, paginationProps, setFilterPopupHeight } =
    props;

  const { makeAuthenticatedApi } = useApiCall();
  const adminApi: AdminApi = useMemo(() => makeAuthenticatedApi(AdminApi), [makeAuthenticatedApi]);

  return (
    <DataRecordTable
      ordering={ordering}
      onOrderBy={onOrderBy}
      data={issuers}
      loading={loading}
      hasPermission={hasPermission}
      paginationProps={paginationProps}
      onGoToDetails={goToDetails}
      setFilterPopupHeight={setFilterPopupHeight}
      cells={[
        {
          title: <Translate name={`studioIssuers.studioIssuersTable.issuer`} />,
          render: ({ companyName }) => companyName,
          orderingFieldName: AdminIssuersListOrderingEnum.COMPANY_NAME_ASC,
          type: CellTypeEnum.text,
          filterName: 'companyName',
          searchFieldName: AdminIssuersValuesRetrieveFieldEnum.COMPANY_NAME,
          getFilterData: (params: any) => adminApi.adminIssuersValuesRetrieve(params),
        },
        {
          title: <Translate name={`studioIssuers.studioIssuersTable.organization`} />,
          render: ({ organizationName }) => organizationName,
          orderingFieldName: AdminIssuersListOrderingEnum.ORGANIZATION_NAME_ASC,
          type: CellTypeEnum.text,
          filterName: 'organizationName',
          searchFieldName: AdminIssuersValuesRetrieveFieldEnum.ORGANIZATION_NAME,
          getFilterData: (params: any) => adminApi.adminIssuersValuesRetrieve(params),
        },
        {
          title: <Translate name={`studioIssuers.studioIssuersTable.productsNumber`} />,
          alignContent: 'right',
          orderingFieldName: AdminIssuersListOrderingEnum.NUMBER_OF_PRODUCTS_ASC,
          type: CellTypeEnum.number,
          filterName: 'numberOfProducts',
          render: ({ numberOfProducts }) => numberOfProducts && <Number>{numberOfProducts}</Number>,
        },
      ]}
    />
  );
};

export default StudioIssuersTable;
